import { Outlet, useLocation } from "react-router-dom";
import { Suspense } from "react";
import { AnimatePresence } from "framer-motion";
import { Navigation as SideNav } from "./navigation";
import { useBootstrapAppData } from "./hooks/useBootstrapAppData";
import RouteFallback from "../_components/loaders/RouteFallback";
import "./AppLayout.scss";

const AppLayout = () => {
  const displayZone = useBootstrapAppData();
  const location = useLocation();

  return (
    <div className="app-layout">
      <SideNav />
      <main className="app-layout__main">
        <AnimatePresence>
          <Suspense fallback={<RouteFallback />}>
            <Outlet key={`${location.pathname}|${displayZone || ""}`} />
          </Suspense>
        </AnimatePresence>
      </main>
    </div>
  );
};

export default AppLayout;
